import { getBrandBusinessName } from "@faire/help-center-utils/serialized-data/getBrand";
import {
  getRetailer,
  getRetailerBusinessName,
} from "@faire/help-center-utils/serialized-data/getRetailer";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";

export const UserInfoSummaryCard: React.FC = () => {
  const retailer = getRetailer();
  const userBusinessName = getBrandBusinessName() ?? getRetailerBusinessName();

  return (
    <>
      {retailer ? (
        <>
          <Typography variant="paragraphSansMedium">
            <StrictLocalMsg
              defaultMessage="Your account"
              description={{ text: "Title of showing retailer account name" }}
            />
          </Typography>
          <Spacer height="1/2x" />
          <Typography>{userBusinessName}</Typography>
        </>
      ) : (
        <>
          <Typography variant="paragraphSansMedium">
            <StrictLocalMsg
              defaultMessage="Your shop"
              description={{ text: "Title of showing brand account name" }}
            />
          </Typography>
          <Spacer height="1/2x" />
          <Typography>{userBusinessName}</Typography>
        </>
      )}
    </>
  );
};
